import { render, staticRenderFns } from "./FinalDraftHistory.vue?vue&type=template&id=44c058af&scoped=true&"
import script from "./FinalDraftHistory.vue?vue&type=script&lang=js&"
export * from "./FinalDraftHistory.vue?vue&type=script&lang=js&"
import style0 from "./FinalDraftHistory.vue?vue&type=style&index=0&id=44c058af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c058af",
  null
  
)

export default component.exports